// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__28hu9","buttons":"SendReceipts_buttons__1cHK9","email":"SendReceipts_email__2D3pe","bookApptTitle":"SendReceipts_bookApptTitle__CH-AU"};